<template>
  <div>
    <CheckListComponent
      typeName="巡回清掃 完了一覧"
      :type="2"
      :claim="false"
      settionStrageName="RoundCheckListStorageItemName">
    </CheckListComponent>
  </div>
</template>

<script>
import CheckListComponent from '../../Patrol/components/CheckListComponent.vue'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    CheckListComponent
  },
}
</script>